import vwfsLogoFooter from '@/images/clients/vwfs-logo.svg'
import type { IPartnerSettings } from '.'

export const VWFS: IPartnerSettings = {
  partner: 'VWFS',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://broker.cebia.cz/test',
    prep: 'https://broker.cebia.cz/prep',
    production: 'https://broker.cebia.cz/prod'
  },
  hosts: [
    'broker-new.cebia.cz'
    // , 'localhost:44470'
  ],
  logo: vwfsLogoFooter
}